import React from "react";
import { toast } from "sonner";
import copyIcon from "../../../../Assets/icons/copy.svg";
import { getSpacing } from "../../../../designTokens";

interface CopyToClipboardButtonProps {
  value: string;
  ariaLabel: string;
  successMessage: string;
  id?: string;
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  value,
  ariaLabel,
  successMessage,
  id,
}) => (
  <button
    type="button"
    id={id}
    aria-label={ariaLabel}
    onClick={(e) => {
      e.stopPropagation();
      try {
        navigator.clipboard.writeText(value);
        toast.success(successMessage);
      } catch (error) {
        console?.error("Failed to copy to clipboard", error);
      }
    }}
    onKeyDown={(e) => e.stopPropagation()}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: getSpacing("2px"),
      border: "none",
      background: "transparent",
      cursor: "pointer",
      flexShrink: 0,
    }}
  >
    <img src={copyIcon} alt="" aria-hidden="true" />
  </button>
);

export default CopyToClipboardButton;
